import { BULLETIN_TYPES, SOCKET_FIELD_MAPPING, ODD_FIELD_MAPPING, DECREASE, INCREASE, MATCH_CARD_PERSONAL_BETS_TAB_ID, MATCH_CARD_POPULAR_BETS_TAB_ID } from 'Store/constants/sportTypes';
import EnvironmentManager from 'Utils/environmentManager';
import { generateSpecialOddsWithOrder, isSelfGenerateRequired } from 'Utils/scoreEventOddListGenerator';

const socketToType = value => {
  let sportType = value?.sportType;
  let bulletinType = value?.isLive ? BULLETIN_TYPES.LIVE : BULLETIN_TYPES.PREMATCH;

  return { bulletinType, sportType };
};

export const isMyTab = (activeSportType, activeBulletinType, value) => {
  const socketType = socketToType(value);
  return activeBulletinType === socketType.bulletinType
    && (activeSportType === socketType.sportType || activeSportType === 9999);
};

const getNewMarket = (market, relatedChange) => {
  return {
    ...market,
    market: {
      ...market.market,
      [ODD_FIELD_MAPPING[relatedChange[SOCKET_FIELD_MAPPING.property]]]: relatedChange[SOCKET_FIELD_MAPPING.newValue]
    }
  };
};

export const homePopulerBetsUpdate = (state, changedOdds, removedOdds, addedOdds) => {
  const changes = changedOdds[0]?.changes;
  const removeds = removedOdds[0]?.changes;
  const addeds = addedOdds[0]?.changes;
  const evId = changes?.[0]?.[SOCKET_FIELD_MAPPING.eventId]
    || removeds?.[0]?.[SOCKET_FIELD_MAPPING.eventId]
    || addeds?.[0]?.[SOCKET_FIELD_MAPPING.eventId];

  if (!evId) {
    return { data: state, isChanged: false };
  }

  return state.reduce((acc, cur, index) => {
    if (cur.id === evId) {
      const marketId = cur.market?.[ODD_FIELD_MAPPING.marketId];
      const outcomeNo = cur.market?.[ODD_FIELD_MAPPING.outcomeNo];

      const relatedChanges = changes?.filter(e =>
        e[SOCKET_FIELD_MAPPING.marketId] === cur.market[ODD_FIELD_MAPPING.marketId]
        && e[SOCKET_FIELD_MAPPING.outcomeNo] === cur.market[ODD_FIELD_MAPPING.outcomeNo]
      );

      if (relatedChanges?.length) {
        acc.data[index] = relatedChanges.reduce(
          (updatedMarket, relatedChange) => getNewMarket(updatedMarket, relatedChange),
          cur
        );

        acc.isChanged = true;
      }

      const removedChange = removeds?.find(e =>
        e[SOCKET_FIELD_MAPPING.marketId] === marketId
        && e[SOCKET_FIELD_MAPPING.outcomeNo] === outcomeNo
      );
      if (removedChange) {
        acc.data[index] = {
          ...cur,
          market: {
            ...cur.market,
            mrs: 0
          }
        };
        acc.isChanged = true;
      }

      const addedChange = addeds?.find(e =>
        e[SOCKET_FIELD_MAPPING.marketId] === marketId
        && e[SOCKET_FIELD_MAPPING.outcomeNo] === outcomeNo
      );
      if (addedChange) {
        acc.data[index] = {
          ...cur,
          market: {
            ...cur.market,
            mrs: 1
          }
        };
        acc.isChanged = true;
      }
    }

    return acc;
  }, { data: state, isChanged: false });
};

export const populerBetsUpdate = (state, wschanges = []) => {
  const newState = [...state];
  const evId = wschanges[0]?.[SOCKET_FIELD_MAPPING.eventId];

  if (!evId) {
    return { data: state, isChanged: false };
  }
  return newState.reduce((acc, cur, index) => {
    if (cur.id === evId) {
      const relatedChanges = wschanges.filter(e =>
        e[SOCKET_FIELD_MAPPING.marketId] === cur.market[ODD_FIELD_MAPPING.marketId]
        && e[SOCKET_FIELD_MAPPING.outcomeNo] === cur.market[ODD_FIELD_MAPPING.outcomeNo]
      );

      if (relatedChanges.length) {
        acc.isChanged = true;

        const updatedMarket = relatedChanges.reduce((marketAcc, relatedChange) => {
          const property = relatedChange[SOCKET_FIELD_MAPPING.property];
          const mappedKey = ODD_FIELD_MAPPING[property];

          if (!mappedKey) {
            return marketAcc;
          }

          return {
            ...marketAcc,
            [mappedKey]: relatedChange[SOCKET_FIELD_MAPPING.newValue]
          };
        }, acc.data[index].market);

        acc.data[index] = {
          ...acc.data[index],
          market: updatedMarket
        };
      }
    }

    return acc;
  }, { data: newState, isChanged: false });
};

export const generateOddId = odd => {
  return `${odd[SOCKET_FIELD_MAPPING.eventId]}:${odd[SOCKET_FIELD_MAPPING.marketId]}:${odd[SOCKET_FIELD_MAPPING.outcomeNo]}`;
};

export const findOddWithId = (id, changesArr) => {
  if (!changesArr?.length) return null;
  return changesArr.find(chg => id === generateOddId(chg));
};

export const filterOddWithId = (id, changesArr) => {
  if (!changesArr?.length) return [];
  return changesArr.filter(chg => id === generateOddId(chg));
};

const oddGroupTabMapper = tabs => {
  return tabs.map(tab => ({
    active: true,
    selected: false,
    id: tab[SOCKET_FIELD_MAPPING.tabId],
    order: tab[SOCKET_FIELD_MAPPING.tabOrder],
    title: tab[SOCKET_FIELD_MAPPING.tabTitle],
    matchCardOdds: []
  }));
};

export const createOddGroup = (oddAddeds, tab) => {
  const generateRequiredTypes = JSON.parse(EnvironmentManager.getMessageText({ key: 'match_card_market_order' }) || '["2-86","2-717"]');

  return oddAddeds?.map(odd => {
    const order = odd[SOCKET_FIELD_MAPPING.tabIdOrder]?.find(t => t[SOCKET_FIELD_MAPPING.tabId] === tab.id)?.[SOCKET_FIELD_MAPPING.matchCardOrder];
    if (!order) return null;

    if (isSelfGenerateRequired(generateRequiredTypes, odd[SOCKET_FIELD_MAPPING.matchCardOdd])) {
      return { ...odd[SOCKET_FIELD_MAPPING.matchCardOdd], matchCardOrder: order, oddList: generateSpecialOddsWithOrder(odd[SOCKET_FIELD_MAPPING.matchCardOdd]) };
    }

    return { ...odd[SOCKET_FIELD_MAPPING.matchCardOdd], matchCardOrder: order };
  }).filter(Boolean);
};

export const findNewAddedTabs = (oddAddeds, oddGroupTabs) => {
  const existingTabIds = new Set(oddGroupTabs.map(tab => tab.id));
  const newTabs = new Map();

  oddAddeds?.forEach(addedOdd =>
    addedOdd[SOCKET_FIELD_MAPPING.tabIdOrder]?.forEach(tab => {
      const tabId = tab[SOCKET_FIELD_MAPPING.tabId];
      if (!existingTabIds.has(tabId)) {
        newTabs.set(tabId, tab);
      }
    })
  );

  return [...newTabs.values()];
};

export const updateMatchCardOdds = ({ relatedMatchOdds, oddRemoves, oddChanges, oddAddeds }) =>{ //oddRemoves, oddChanges, oddAddeds değişikliklerinin hepsini uygular ve oddların son halini döner
  if (!relatedMatchOdds?.oddGroupTabs) return { isUpdated: false, relatedMatchOdds };
  let isUpdated = false;
  if (oddAddeds?.length) {
    const newAddedTabs = findNewAddedTabs(oddAddeds, relatedMatchOdds.oddGroupTabs);

    if (newAddedTabs?.length) {
      isUpdated = true;
      const mappedTabs = oddGroupTabMapper(newAddedTabs);
      relatedMatchOdds.oddGroupTabs.push(...mappedTabs);
    }
  }

  if (oddRemoves?.length || oddChanges?.length || oddAddeds?.length) {
    relatedMatchOdds.oddGroupTabs.forEach(tabs => {

      if (oddAddeds?.length) {
        const newAddeds = createOddGroup(oddAddeds, tabs);
        const oldData = tabs.matchCardOdds;

        newAddeds.forEach(newData => {
          const sameItemIndex = oldData.findIndex(e=> e.marketSubType === newData.marketSubType && e.marketType === newData.marketType && e.specialValue === newData.specialValue );
          if (sameItemIndex > -1) {
            oldData.splice(sameItemIndex, 1);
          }
        });

        tabs.matchCardOdds = [...oldData, ...newAddeds];

        isUpdated = true;
        tabs.matchCardOdds.sort((a, b) => a.matchCardOrder - b.matchCardOrder);
      }

      tabs.matchCardOdds.forEach(matchCardOdd => {

        let newList = matchCardOdd.oddList;

        //#region odd-removed
        if (oddRemoves?.length) {
          newList = newList.filter(odd => {
            // eslint-disable-next-line max-nested-callbacks
            const shouldDelete = !oddRemoves?.some(removedOdd => removedOdd[SOCKET_FIELD_MAPPING.marketId] === odd[ODD_FIELD_MAPPING.marketId]);

            if (shouldDelete) isUpdated = true;
            return shouldDelete;
          });
        }

        if (!newList?.some(odd=>odd[ODD_FIELD_MAPPING.marketId])) { //newList'te sadece fakeOddlar(marketId si olmayan oddlar) kaldıysa, oddGroup silinmeli.
          newList = [];

          isUpdated = true;
        }
        //#endregion

        //#region odd-changed
        if (oddChanges?.length) {
          newList.forEach(odd =>{
            const relatedOddChange = filterOddWithId(odd.id, oddChanges);
            if (Array.isArray(relatedOddChange) && relatedOddChange.length > 0) {
              // eslint-disable-next-line max-nested-callbacks
              relatedOddChange.forEach(change => {
                isUpdated = true;
                odd[ODD_FIELD_MAPPING[change[SOCKET_FIELD_MAPPING.property]]] = change[SOCKET_FIELD_MAPPING.newValue];

                if (change[SOCKET_FIELD_MAPPING.property] === 'value') {
                  odd[ODD_FIELD_MAPPING.changeType] = (change[SOCKET_FIELD_MAPPING.oldValue] * 1) < (change[SOCKET_FIELD_MAPPING.newValue] * 1) ? INCREASE : DECREASE;
                } else if (change[SOCKET_FIELD_MAPPING.property] === 'topWinValue') {
                  odd[ODD_FIELD_MAPPING.changeType] = (change[SOCKET_FIELD_MAPPING.oldValue] * 1) < (change[SOCKET_FIELD_MAPPING.newValue] * 1) ? INCREASE : DECREASE;
                }

              });
            }
          }
          );
        }
        //#endregion

        if (!newList.length) { //newList boş kaldıysa odd u tamamen sil
          matchCardOdd.shouldDelete = true;
          isUpdated = true;
        } else {
          matchCardOdd.oddList = newList;
        }

      });

      tabs.matchCardOdds = tabs.matchCardOdds.filter(e=>!e.shouldDelete); //newList boş kaldıysa odd u tamamen sil
    });
  }

  if (isUpdated) {
    const newMatchCardOdds = {
      ...relatedMatchOdds,
      oddGroupTabs: relatedMatchOdds.oddGroupTabs.filter(tab => tab.matchCardOdds.length || (tab.id === MATCH_CARD_PERSONAL_BETS_TAB_ID || tab.id === MATCH_CARD_POPULAR_BETS_TAB_ID  )).sort((a, b) => a.order - b.order)
    };

    return { newOdds: newMatchCardOdds, isUpdated };
  }

  return { newOdds: relatedMatchOdds, isUpdated };
};

export const getWebSocketTopics = () => {
  const topicsFromCMS = EnvironmentManager.getMessageText({
    key: 'web_socket_topics'
  });

  const topics = (topicsFromCMS || '')
    .split(',')
    .map(t => t.trim())
    .filter(Boolean);

  if (topics.length) return topics;

  console.warn('[WebSocket] CMS boş, default topicler kullanılıyor');
  return ['updatedMobileEventsV3', 'perform-match-details-socket'];
};

export const subscribeAllTopics = async wsInstance => {

  await EnvironmentManager.waitForMessages();

  const topics = getWebSocketTopics();

  wsInstance.subscribedTopics = wsInstance.subscribedTopics || [];

  topics.forEach(topic => {
    if (!wsInstance.subscribedTopics.includes(topic)) {
      wsInstance.sendMessage({
        kind: 'SubscribeStreamTopic',
        topic
      });

      wsInstance.subscribedTopics.push(topic);
    }
  });
};

//slider helper

export const hasOddWithOutcomeNo = (odds = [], outcomeNo) =>
  odds.some(
    odd => odd[SOCKET_FIELD_MAPPING.outcomeNo] === outcomeNo || odd.ocn === outcomeNo
  );

export const groupOddsByMarketId = odds =>
  (odds || []).reduce((acc, odd) => {
    const marketId = odd[SOCKET_FIELD_MAPPING.marketId] || odd.mrId;

    if (!acc[marketId]) {
      acc[marketId] = [];
    }

    acc[marketId].push(odd);

    return acc;
  }, {});

export const getAddedOddsFromMarketGroup = payloadValue => {
  const changes = payloadValue?.changes || [];

  return changes.flatMap(change =>
    change?.mrkGrp?.mgs?.flatMap(group =>
      group?.mco?.oddList || []
    ) || []
  );
};

export const createAddedOddsMap = addedOddsFromMarketGroup =>
  (addedOddsFromMarketGroup || []).reduce((acc, odd) => {
    acc[`${odd.mrId}:${odd.ocn}`] = odd;
    return acc;
  }, {});

export const isMarketOpen = odds => {
  if (!Array.isArray(odds) || odds.length === 0) {
    return false;
  }

  return odds.some(odd => odd?.mrs !== 0);
};

export const getFirstOpenMarket = marketGroups => {
  if (!marketGroups || typeof marketGroups !== 'object') {
    return {};
  }

  const firstOpenKey = Object.keys(marketGroups)
    .sort((a, b) => Number(a) - Number(b))
    .find(key => isMarketOpen(marketGroups[key]));

  if (!firstOpenKey) {
    return {};
  }

  return {
    [firstOpenKey]: marketGroups[firstOpenKey]
  };
};

export const createWsOddsMap = oddChanges =>
  (oddChanges || []).reduce((acc, change) => {
    const oddId = generateOddId(change);

    const marketId = change[SOCKET_FIELD_MAPPING.marketId];
    const outcomeNo = change[SOCKET_FIELD_MAPPING.outcomeNo];
    const property = change[SOCKET_FIELD_MAPPING.property];
    const newValue = change[SOCKET_FIELD_MAPPING.newValue];

    if (!acc[oddId]) {
      acc[oddId] = {
        id: oddId,
        mrId: Number(marketId),
        ocn: outcomeNo
      };
    }

    switch (property) {
      case 'value':
        acc[oddId].val = newValue;
        break;

      case 'topWinValue':
        acc[oddId].tval = newValue;
        break;

      case 'marketStatus':
        acc[oddId].mrs = newValue;
        break;

      default:
        acc[oddId][property] = newValue;
        break;
    }

    return acc;
  }, {});

export const updateMarketGroupsStatus = (marketGroups, status) =>
  Object.keys(marketGroups || {}).reduce((acc, marketKey) => {
    acc[marketKey] = (marketGroups[marketKey] || []).map(odd => ({
      ...odd,
      mrs: status
    }));

    return acc;
  }, {});

export const createUpdatedMainSliderV2MarketGroups = ({
  item,
  oddRemoves,
  oddAddeds,
  oddChanges,
  addedOddsFromMarketGroup = []
}) => {
  const wsOddsMap = createWsOddsMap(oddChanges);

  const removedOddsByMarket = groupOddsByMarketId(oddRemoves);
  const addedOddsByMarket = groupOddsByMarketId(oddAddeds);
  const addedOddsMap = createAddedOddsMap(addedOddsFromMarketGroup);

  return Object.keys(item.marketGroups || {}).reduce((acc, marketKey) => {
    const marketOdds = item.marketGroups[marketKey] || [];
    const realMarketId = marketOdds[0]?.mrId;

    const removedOddsForMarket = removedOddsByMarket[realMarketId] || [];
    const addedOddsForMarket = addedOddsByMarket[realMarketId] || [];

    acc[marketKey] = marketOdds.map(odd => {
      if (hasOddWithOutcomeNo(removedOddsForMarket, odd.ocn)) {
        return {
          ...odd,
          mrs: 0
        };
      }

      const addedOdd = addedOddsMap[`${realMarketId}:${odd.ocn}`];

      if (
        hasOddWithOutcomeNo(addedOddsForMarket, odd.ocn)
        && addedOdd
      ) {
        return {
          ...odd,
          ...addedOdd
        };
      }

      const relatedOddChanges = filterOddWithId(odd.id, oddChanges);

      if (!relatedOddChanges.length) {
        return odd;
      }

      return {
        ...odd,
        ...wsOddsMap[odd.id]
      };
    });

    return acc;
  }, {});
};

export const getMainSliderV2Markets = (item, marketGroups) => {
  const currentMarketId = Object.keys(item.markets || {})[0];

  const firstOpenMarket = getFirstOpenMarket(marketGroups);
  const firstOpenMarketId = Object.keys(firstOpenMarket)[0];

  if (!firstOpenMarketId) {
    return {};
  }

  return firstOpenMarketId === currentMarketId
    ? {
      [currentMarketId]: marketGroups[currentMarketId]
    }
    : firstOpenMarket;
};

//
